import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import BibleReader from './pages/BibleReader';
import SearchPage from './pages/SearchPage';
import About from './pages/About';
import Salvation from './pages/Salvation';
import StateMottos from './pages/StateMottos';
import WhyKJV from './pages/WhyKJV';
import Patriotic from './pages/Patriotic';
import Conservative from './pages/Conservative';
import Liberal from './pages/Liberal';
import Apolitical from './pages/Apolitical';
import American from './pages/American';
import SideBySide from './pages/SideBySide';
import FAQ from './pages/FAQ';
import FreeBibles from './pages/FreeBibles';

function App() {
  return (
    <>
      <div className="stars" />
      <Navbar />
      <ScrollToTop />
      <div className="page-wrap">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/bible" element={<BibleReader />} />
          <Route path="/bible/:bookId" element={<BibleReader />} />
          <Route path="/bible/:bookId/:chapter" element={<BibleReader />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/salvation" element={<Salvation />} />
          <Route path="/state-mottos" element={<StateMottos />} />
          <Route path="/why-kjv" element={<WhyKJV />} />
          <Route path="/patriotic" element={<Patriotic />} />
          <Route path="/conservative" element={<Conservative />} />
          <Route path="/liberal" element={<Liberal />} />
          <Route path="/apolitical" element={<Apolitical />} />
          <Route path="/american" element={<American />} />
          <Route path="/side-by-side" element={<SideBySide />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/free-bible" element={<FreeBibles />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
}

export default App;
